import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Dropdown } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { NavLink } from '../../../../lib/components/link';
import classes from './desktopNav.css';
import { MenuItemType } from '../../../../lib/proptypes/menu.proptypes';
import lockIcon from '../../../../assets/images/key-icon-small.svg';
import downArrow from '../../../../assets/images/down-arrow.svg';

// const log = debug('huddle:app:nav:desktop:navdropdownmenu');

const MenuItemButton = item => (
  item.action || item.url
    ? <NavLink {...item} style={{ color: 'inherit' }} exact>
      {item.label}<img src={downArrow} alt="" className={classes.arrowIcon} />
    </NavLink>
    : <span>{item.label}</span>
);

MenuItemButton.propTypes = {
  item: MenuItemType.isRequired,
};

const NavDropdownMenuItem = ({ item, isLoggedIn }) => (
  <NavLink
    className={classes.dropdownItem}
    activeClassName="active"
    down
    exact
    {...item}
  >
    <span>{item.label}</span>
    {(!isLoggedIn && item.restricted) && <img src={lockIcon} alt="Restricted access" />}
  </NavLink>
);

NavDropdownMenuItem.propTypes = {
  item: MenuItemType.isRequired,
  isLoggedIn: PropTypes.bool.isRequired,
};

const menuFactory = ({ children, isLoggedIn }) =>
  children.map(subItem => (
    <NavDropdownMenuItem
      key={subItem.key}
      item={subItem}
      isLoggedIn={isLoggedIn}
    />
  ),
);

class NavDropdownMenu extends PureComponent {
  static propTypes = {
    item: MenuItemType.isRequired,
    children: PropTypes.node,
    offset: PropTypes.number,
    isLoggedIn: PropTypes.bool.isRequired,
  };

  static defaultProps = {
    children: null,
    offset: null,
  }

  render = () => {
    const { item, children, offset, isLoggedIn } = this.props;
    return (
      <Dropdown
        item
        simple
        icon={null}
        className={classes.menuButtonStyle}
        trigger={MenuItemButton(item)}
        open={false}
      >
        {children
          ? <Dropdown.Menu
            className={classes.teamDropDownMenu}
            style={{ left: `-334px` }}
          >
            {children}
          </Dropdown.Menu>
          : <Dropdown.Menu className={classes.dropDownMenuStyle}>
            {menuFactory({ isLoggedIn, ...item })}
          </Dropdown.Menu>}
      </Dropdown>
    );
  };
}

const mapStateToProps = state => ({
  isLoggedIn: state.auth.loggedIn,
});

export default connect(mapStateToProps)(NavDropdownMenu);



// WEBPACK FOOTER //
// ./src/app/components/Nav/DesktopNav/NavDropdownMenu.js